function HistoryIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="6"
        cy="5"
        r="2.5"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path
        d="M8.5 5 H17.5 a3.5 3.5 0 0 1 0 7 H6.5 a3.5 3.5 0 0 0 0 7 H15"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="18" cy="19" r="1.5" fill="currentColor" />
    </svg>
  );
}

export default HistoryIcon;
